import { useCallback, useEffect, useState } from "react";
import { fetchPackage } from "../services/api";

export function usePackage(id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const pkg = await fetchPackage(id);
      setData(pkg);
    } catch (err) {
      setError(err.message || "Error cargando paquete");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, refetch: load };
}
